<template>
	<div class="result-upper-row">
      <div class="container">
        <div class="row align-items-start flex-column-reverse flex-sm-row">
          <div class="col-sm-12 col-lg-6 col-md-7">
            <div class="backbutton-container">
              <a href="/goals-custom" class="btn-textlinkLeftIcon"><span><i class="ph-arrow-left-bold"></i></span>back</a>
            </div>
            <div class="investment-container">
              <h2 class="hf_heading02">What you need to know about your investment</h2>
              <!-- CALCULATOR SECTION -->
              <div class="calc-outer-container calculator-box">
                <div class="goals-calc-container">
                  <div class="goals-calculator-box">
                    <div class="calculator">
                    <!-- calculator section for emergency goal -->
                    <form action="show-emrgoal-result" method="post" id="showEmrResult">
                      <input type="hidden" v-model="_token" name="_token">
                      <p class="hf_heading06 hf_light">Tell us how much you spend monthly</p>
                      <div class="form-group dynamic-input">
                        <label>I and my family spend<span class="inr-symbol hf_dark">&#8377;</span></label>
                        <input type="text" id="amountEmrReqd" name="amountEmrReqd" v-model="amountEmrReqdPass" class="restDot numbersonly" :class="amountEmrReqdMClass" @keyup="resetEmrCalculation()" placeholder="50,000" min="0" maxlength="14" required>
                        <span class="plane-text">per month.</span>
                      </div>
                      <div class="notification-message">
                        <p v-show="showEmrError" class="errorMessage inflation-text hf_bodytext02">
                          <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                          {{ showEmrErrorText }}
                        </p>
                      </div>
                      <div class="recalculate-button-container">
                        <a href="javascript:void(0)" type="button" class="btn-textlinkLeftIcon lg-textlinkleftIcon" ref="myBtn" @click.stop="showEmrResult($event)"><span class="ph-arrow-clockwise-bold"></span>Recalculate</a>
                      </div>
                    </form>
                    <!-- end calculator section for emergency goal -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- END CALCULATOR SECTION -->
              <!-- CALCULATIONS RESULT SECTION -->
              <div class="calc-result-container">
                <!-- emergency goal result -->
                <p class="hf_bodytext01 goalEmergency">Considering you and your family spend <span class="inr-symbol hf_dark">&#8377;</span><span class="calculation-number">{{ amountEmrReqdHtml }}</span> per month, we advise you to accumulate an emergency corpus of <span class="inr-symbol hf_dark">&#8377;</span><span class="calculation-number">{{ fvResultHtml }}</span>.</p>
                <!-- end emergency goal result -->
              </div>
              <!-- END CALCULATIONS RESULT SECTION -->
              <!-- INSIGHT SECTION FOR ONLY WEALTH GOAL -->
              <div class="insight-container goalWealth">
                <!-- insights for emergency goal -->
                <ul class="insight-list goalEmergency">
                  <li>Many people lost their jobs during the lockdown and realized an emergency corpus helps to stay financially worry-free during unprecedented times.</li>
                  <li>With an emergency corpus, you will never have to rely on someone for financial help and worry about sustaining yourself.</li>
                </ul>
                <!-- end insights for emergency goal -->
              </div>
              <!-- END INSIGHT SECTION FOR ONLY WEALTH GOAL -->
            </div>
          </div>
          <!-- GOAL IMAGES SECTION -->
          <div class="col-sm-12 col-lg-6 col-md-5">
            <div class="goal-image-box">
              <img fetchpriority="high" src="img/goal-emergency.webp" class="goalEmergency" width="401" height="388" alt="">
            </div>
          </div>
          <!-- END GOAL IMAGES SECTION -->
        </div>
      </div>
    </div>
</template>

<script>
export default {
  created() {},
  data() {
    return {
    	_token : this.$token,
    	// goalType: 'HEALTH',
    	inflation: '',
    	accmpYear: '',
    	fvResult: '',
    	fvResultHtml: '',
      amountEmrReqdHtml: '',
      amountEmrReqdMClass: '',
      mandatoryClassName: 'redunderline',
      showEmrErrorText: '',
      showEmrError: false,
      amountEmrReqdPass: '',
    };
  },
  props: {
    amountEmrReqd: { type:String, default:''},
  },
  watch: {
	  amountEmrReqdPass(){
      var res =  this.formatAmount(this.amountEmrReqdPass)
      this.amountEmrReqdPass = res;
    },
  },
  mounted(){
    // console.log("mounted event triggered");
    this.amountEmrReqdPass = this.amountEmrReqd;
    let temp = this.$refs.myBtn;
    setTimeout(function() {
      temp.click();
    }, 1000);
  },
  methods: {
    showEmrResult(e){
      // console.log("Click event triggered");

      //Check for validation and collect data for calculations
      //======================================================
      var amountEmrReqd = this.amountEmrReqdPass;
      amountEmrReqd = String(amountEmrReqd).replace(new RegExp(',', 'g'), '');
      // this.amountEmrReqdHtml = this.shorthandCurrency(Math.round(amountEmrReqd), true);
      
      if(amountEmrReqd == "" || amountEmrReqd == undefined){
        this.showEmrErrorText = "Please enter mandatory data first";
        this.showEmrError = true;
        this.amountEmrReqdMClass = this.mandatoryClassName;
      }else{
        //remove all redunderline class for mandatory
        //============================================
        this.amountEmrReqdMClass = "";

        //Check all the basic validations eg.age, amt
        //=============================================
        axios.post('/chkEmrGoalValidations',{amountReqd: amountEmrReqd, calcReq: 1, _token: this.$token})
        .then((responseEmr)=>{
          // console.log(responseEmr);
          let resEmrData = responseEmr.data;
          if(resEmrData.status == true){
            this.showEmrErrorText = "";
            this.showEmrError = false;
            
            let emrsavingduramt = resEmrData.emrsavingduramt; 
            // console.log("emrsavingduramt = "+emrsavingduramt);
            //================================================
            // Calculate Future value FV
            //================================================   
            this.amountEmrReqdHtml = this.shorthandCurrency(Math.round(amountEmrReqd), true);
            this.fvResult = amountEmrReqd * emrsavingduramt;
            this.fvResultHtml = this.shorthandCurrency(Math.round(this.fvResult), true);
          }else{
            if(resEmrData.error == undefined){
              this.showEmrErrorText = "Page session expired, Please refresh the page";
              this.showEmrError = true;
            }else{
              this.showEmrErrorText = resEmrData.error;
              this.showEmrError = true;
            }
          }
        }).catch(responseEmr => {
            console.log(responseEmr.data);
        })
      }
    },
    resetEmrCalculation(){
      // On keyup of field show button for calculation and hide result 
      //================================================================
      this.showEmrErrorText = "";
      this.showEmrError = false;
    }
  },
};
</script>

<style lang="scss" scoped></style>
